import { AuctionBidHistoryAnonymizedDTO, PropertyBidHistoryAnonymizedDTO } from "../DTO/propertyBidHistoryAnonymizedDTO";
import { AuctionBid } from "./auctionBid";

/** one auction sequence of the anonymized bid history (masked bids of the public view) */
export class AuctionBidHistoryAnonymized{
    public auctionId!:number;
    public scheduleSeqNo!:number;
    public void?:boolean;
    public voidIndex?:number;
    public auctionBids:AuctionBid[] = [];

    get voidInfo(){
        if(this.void && this.voidIndex) return ` (Void${this.voidIndex>0? ` #${this.voidIndex}` : ''})`;
        else return '';
    }

    public static mapFromDTO(param:AuctionBidHistoryAnonymizedDTO) : AuctionBidHistoryAnonymized
    {
        let obj = new AuctionBidHistoryAnonymized();
        try
        {
            obj.auctionId = param.auctionId;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            obj.void = param.void;
            obj.voidIndex = param.voidIndex;
            //no user id: the anonymized history never marks bids as the viewer's own
            obj.auctionBids = (param.auctionBids ?? []).map(b => AuctionBid.mapFromDTO(b, undefined));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}

/** bid history of a property for client users: one entry per auction sequence, no bidder details */
export class PropertyBidHistoryAnonymized{
    public propertyId!:number;
    public auctionBidHistories:AuctionBidHistoryAnonymized[] = [];

    public static mapFromDTO(param:PropertyBidHistoryAnonymizedDTO) : PropertyBidHistoryAnonymized
    {
        let obj = new PropertyBidHistoryAnonymized();
        try
        {
            obj.propertyId = param.propertyId;
            obj.auctionBidHistories = (param.auctionBidHistories ?? []).map(abh => AuctionBidHistoryAnonymized.mapFromDTO(abh));
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}
